var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF1Car(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_387",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29226",
    "data-name": "Group 29226",
    transform: "translate(434 10575)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -434, -10575)",
    filter: "url(#Ellipse_387)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_387-2",
    "data-name": "Ellipse 387",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_12_",
    "data-name": "svgexport-17 (12)",
    transform: "translate(-420 -10548)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "astroligical_calendar",
    "data-name": "astroligical calendar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "F1_car",
    "data-name": "F1 car"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50498",
    "data-name": "Path 50498",
    d: "M33.424,2,31.52.105h-.005A.314.314,0,0,0,31.282,0H29.267a.317.317,0,0,0,0,.635h.873L31.488,2Z",
    transform: "translate(-10.578 0)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50499",
    "data-name": "Path 50499",
    d: "M41.885,9.331,31.8,5.96,29.728,3.891A2.532,2.532,0,0,0,27.435,3.2L21.069,4.47a.451.451,0,0,1-.126-.31V4.074A.454.454,0,0,1,21.4,3.62h.815a.635.635,0,0,0,.635-.635V2.351a.635.635,0,0,0-.635-.635h-4.6a7.275,7.275,0,0,0-4.294,1.4A7.275,7.275,0,0,1,9.02,4.52H8.25a.635.635,0,0,0-.635.635V6.793a.635.635,0,0,1-.635.635H6.346a.635.635,0,0,1-.635-.635V4.214a.635.635,0,0,0-.635-.635H.635A.635.635,0,0,0,0,4.214V7.035A.635.635,0,0,0,.351,7.6l7.131,3.565a.635.635,0,0,0,.284.067h20.69a.635.635,0,0,0,.2-.033l5.39-1.8A.952.952,0,0,1,34.5,9.37l8.527,1.712c.393.079.76-.6.76-1.005ZM23.3,5.524a.452.452,0,0,1-.326-.14l4.709-.942a1.265,1.265,0,0,1,1.147.347l.734.735Z",
    transform: "translate(0 -0.627)",
    fill: "#e53935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50500",
    "data-name": "Path 50500",
    d: "M29.777,13.586l-1.043,2.087a.635.635,0,0,1-.568.351H8.25a.635.635,0,0,1-.635-.635v-.317H.635A.635.635,0,0,1,0,14.437V13.8a.635.635,0,0,1,.635-.635H7.615v-.317a.635.635,0,0,1,.635-.635h3.731a3.249,3.249,0,0,1,2.3.952,3.251,3.251,0,0,0,2.3.952h3.685a27.658,27.658,0,0,0,8.747-1.42.635.635,0,0,1,.768.886Zm10.839,1.485h4.442a.635.635,0,0,0,.635-.635V13.8a.635.635,0,0,0-.635-.635H40.616a.635.635,0,0,0-.635.635v.635A.635.635,0,0,0,40.616,15.071Z",
    transform: "translate(0 -4.463)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_505",
    "data-name": "Ellipse 505",
    cx: 3.808,
    cy: 3.808,
    r: 3.808,
    transform: "translate(1.904 4.897)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_506",
    "data-name": "Ellipse 506",
    cx: 2.69,
    cy: 2.69,
    r: 2.69,
    transform: "translate(3.022 6.015)",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50501",
    "data-name": "Path 50501",
    d: "M7.269,14.992a3.007,3.007,0,1,1,3.007-3.007A3.007,3.007,0,0,1,7.269,14.992Zm0-5.379a2.372,2.372,0,1,0,2.372,2.372A2.372,2.372,0,0,0,7.269,9.613Z",
    transform: "translate(-1.557 -3.28)",
    fill: "#ff0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_507",
    "data-name": "Ellipse 507",
    cx: 0.956,
    cy: 0.956,
    r: 0.956,
    transform: "translate(4.756 7.749)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_508",
    "data-name": "Ellipse 508",
    cx: 3.808,
    cy: 3.808,
    r: 3.808,
    transform: "translate(30.462 4.897)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_509",
    "data-name": "Ellipse 509",
    cx: 2.69,
    cy: 2.69,
    r: 2.69,
    transform: "translate(31.58 6.015)",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50502",
    "data-name": "Path 50502",
    d: "M52.269,14.992a3.007,3.007,0,1,1,3.007-3.007A3.007,3.007,0,0,1,52.269,14.992Zm0-5.379a2.372,2.372,0,1,0,2.372,2.372A2.372,2.372,0,0,0,52.269,9.613Z",
    transform: "translate(-17.999 -3.28)",
    fill: "#ff0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_510",
    "data-name": "Ellipse 510",
    cx: 0.956,
    cy: 0.956,
    r: 0.956,
    transform: "translate(33.314 7.749)",
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF1Car);
export default __webpack_public_path__ + "static/media/f1car.6424bb4c31b7c4b1753c03514cace64c.svg";
export { ForwardRef as ReactComponent };